import styled from 'styled-components';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const ServiceCheckbox = styled(Checkbox)`
  height: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 50px;
  }
`;

export const NoveltyLabel = styled(Typography.Caption).attrs(() => ({
  $variant: '3',
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  padding: 0 10px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.palette.brand.main};
  color: ${({ theme }) => theme.palette.system.white};
`;
